const master = document.getElementById("stalkerMaster")
const slave = document.getElementById("stalkerSlave")
const slaveClose = document.getElementById("stalkerClose")
var pos = {x:0,y:0}
var mouse = {x:pos.x, y:pos.y}
const speed = 0.3
var masterSetX = gsap.quickSetter(master, "x", "px");
var masterSetY = gsap.quickSetter(master, "y", "px");
var slaveSetX = gsap.quickSetter(slave, "x", "px");
var slaveSetY = gsap.quickSetter(slave, "y", "px");
var slaveCloseSetX = gsap.quickSetter(slaveClose, "x", "px");
var slaveCloseSetY = gsap.quickSetter(slaveClose, "y", "px");
document.addEventListener("mousemove", function(event) {
  mouse.x = event.pageX;
  mouse.y = event.pageY;
});
gsap.ticker.add(function() {
  var dt = 1.0 - Math.pow(1.0 - speed, gsap.ticker.deltaRatio()); 
  pos.x += (mouse.x - pos.x) * dt;
  pos.y += (mouse.y - pos.y) * dt;
  masterSetX(pos.x);
  masterSetY(pos.y);
  slaveSetX(pos.x);
  slaveSetY(pos.y);
  slaveCloseSetX(pos.x);
  slaveCloseSetY(pos.y);
})
const $stalker = $('#stalkerSlave')
const $stalkerClose = $('#stalkerClose')
var isCloseFlg = false
$('.js-stalkerArea').on('mousemove', function(e) {
  $stalker.addClass('isIn');
})
$('.js-stalkerArea').on('mouseout', function(e) {
  $stalker.removeClass('isIn');
})
$('.js-stalkerCloseArea').on('mousemove', function(e) {
  $stalkerClose.addClass('isIn');
})
$('.js-stalkerCloseArea').on('mouseout', function(e) {
  $stalkerClose.removeClass('isIn');
})